import { useState } from "react";
import { faqs } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="你可能想了解这些"
          subtitle="关于香香漫画的推荐、排行、分类与新作更新，这里整理了读者最常问的几个问题。"
          align="center"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const isOpen = open === index;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen
                    ? "border-primary-200 bg-background-50"
                    : "border-background-200 bg-background-50 hover:border-background-300"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <h3 className="flex items-center gap-3 text-base font-medium text-foreground-950 md:text-lg">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className="ri-question-line text-sm" aria-hidden="true"></i>
                    </span>
                    {faq.q}
                  </h3>
                  <i
                    className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-xl text-foreground-400`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[4.5rem] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[4.25rem]">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}